/** AP03 copy (one group per control; a ticket edits only its own file). */
export const ap03PtBr = {
  title: 'Cobertura de despesas incorridas',
  description:
    'Contas registradas com competência no período devem estar contabilizadas ou invalidadas.',
  prerequisite: 'Requer fontes esperadas para serviços não capturados.',
  diagnosticLabel: 'Diagnóstico de fontes conhecidas',
  unknownAmount: 'Valor desconhecido',
  reasons: {
    APPROVED_BILL_WITHOUT_JOURNAL: {
      title: 'Conta aprovada sem lançamento',
      item: 'Conta aprovada sem lançamento efetivo',
    },
    PENDING_BILL_WITH_SERVICE_EVIDENCE: {
      title: 'Conta pendente com evidência de serviço',
      item: 'Conta aguardando aprovação, com evidência de serviço prestado',
    },
    PRE_APPROVAL_BILL_WITHOUT_RECOGNITION: {
      title: 'Conta do período ainda não reconhecida',
      item: 'Conta em rascunho ou aprovação, sem lançamento efetivo',
    },
    PO_RECEIPT_UNRECOGNIZED_EXPENSE: {
      title: 'Recebimento de pedido de compra não reconhecido',
      item: 'Recebimento classificado como despesa, sem conta que o reconheça',
    },
    MISSING_RECURRING_OCCURRENCE: {
      title: 'Ocorrência recorrente sem fonte',
      item: 'Ocorrência recorrente do mês sem conta ou estimativa',
    },
    other: {
      title: 'Outra pendência',
      item: 'Pendência de fonte conhecida',
    },
  },
  subjects: {
    AP_BILL: 'Conta a pagar',
    PURCHASE_ORDER_RECEIPT: 'Recebimento de pedido de compra',
    AP_VENDOR_RECURRING_BILL: 'Modelo recorrente',
    other: 'Registro',
  },
  detail: {
    scopeNote:
      'O controle analisa os registros existentes no sistema. Toda conta em rascunho, enviada ou pendente de aprovação com competência no período deve ser aprovada e contabilizada, coberta por estimativa ou invalidada. Obrigações ainda não cadastradas não fazem parte deste diagnóstico.',
    documentAmount: 'Valor do documento',
    openBill: 'Abrir conta',
    openReceipt: 'Abrir recebimento',
    openRecurringBills: 'Abrir modelos do fornecedor',
    truncated: 'Lista truncada: mostrando {{shown}} de {{count}} pendências.',
    unknownCount_one: '{{count}} pendência com valor desconhecido',
    unknownCount_other: '{{count}} pendências com valor desconhecido',
  },
};

export const ap03En: typeof ap03PtBr = {
  title: 'Incurred expense coverage',
  description: 'Bills recorded with competency in the period must be recognized or invalidated.',
  prerequisite: 'Needs expected sources for uncaptured services.',
  diagnosticLabel: 'Known-source diagnostic',
  unknownAmount: 'Unknown amount',
  reasons: {
    APPROVED_BILL_WITHOUT_JOURNAL: {
      title: 'Approved bill without a journal',
      item: 'Approved bill with no effective journal',
    },
    PENDING_BILL_WITH_SERVICE_EVIDENCE: {
      title: 'Pending bill with service evidence',
      item: 'Bill awaiting approval, with evidence the service was rendered',
    },
    PRE_APPROVAL_BILL_WITHOUT_RECOGNITION: {
      title: 'Period bill not yet recognized',
      item: 'Draft or approval-stage bill with no effective journal',
    },
    PO_RECEIPT_UNRECOGNIZED_EXPENSE: {
      title: 'Unrecognized purchase-order receipt',
      item: 'Receipt classified as expense, with no recognition for it',
    },
    MISSING_RECURRING_OCCURRENCE: {
      title: 'Recurring occurrence with no source',
      item: "This month's recurring occurrence, with no bill or estimate",
    },
    other: {
      title: 'Other finding',
      item: 'Known-source finding',
    },
  },
  subjects: {
    AP_BILL: 'Bill',
    PURCHASE_ORDER_RECEIPT: 'Purchase-order receipt',
    AP_VENDOR_RECURRING_BILL: 'Recurring template',
    other: 'Record',
  },
  detail: {
    scopeNote:
      'This control analyzes records already in the system. Every draft, submitted, or pending-approval bill with competency in the period must be approved and recognized, covered by an estimate, or invalidated. Obligations that were never entered are outside this diagnostic.',
    documentAmount: 'Document amount',
    openBill: 'Open bill',
    openReceipt: 'Open receipt',
    openRecurringBills: 'Open vendor templates',
    truncated: 'List truncated: showing {{shown}} of {{count}} findings.',
    unknownCount_one: '{{count}} finding with an unknown amount',
    unknownCount_other: '{{count}} findings with an unknown amount',
  },
};
